import { Card, Typography, List, ListItemButton, ListItemText } from '@mui/material';
import { memo } from 'react';
import PropTypes from 'prop-types';
import { cardStyle } from '../TransitionStyles';
import { DueDiligenceFormTitles } from '../formTitlesLists';

TableOfContents.propTypes = {
  activeSection: PropTypes.number,
  formRefs: PropTypes.array,
};

export default function TableOfContents({ activeSection, formRefs }) {
  const handleFormClick = (index) => {
    formRefs[index]?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const TableOfContentList = memo(() => (
    <>
      {DueDiligenceFormTitles?.map((form, formIdx) => (
        <ListItemButton
          onClick={() => handleFormClick(formIdx)}
          dense
          key={form.title}
          sx={{
            wordBreak: 'break-word',
            cursor: 'pointer',
            color: formIdx === activeSection ? 'info.main' : 'text.primary',
            textDecoration: formIdx === activeSection ? 'underline' : 'none',
            py: 0,
          }}
        >
          <ListItemText primary={form.title} />
        </ListItemButton>
      ))}
    </>
  ));

  return (
    <Card sx={cardStyle}>
      <Typography variant="subtitle1" color="info.main" align="center">
        Table of Contents
      </Typography>
      <List>
        <TableOfContentList />
      </List>
    </Card>
  );
}
